import React from "react";
import { Paper, PaperProps, styled } from "@mui/material";
import { tabPanelBottomPadding, tabPanelTopPadding } from "../../styles/theme";
import { pxToRem } from "../../platform-style";

export const TabPanelPaper = styled(Paper)(({ theme }) => ({
  overflowY: "auto",
  scrollbarWidth: "thin",
  paddingLeft: pxToRem(16),
  paddingRight: pxToRem(16),
  paddingTop: pxToRem(tabPanelTopPadding),
  paddingBottom: pxToRem(tabPanelBottomPadding),
  padding: 16,
  boxSizing: "border-box",
  backgroundColor: theme.palette.background.paper,
  typography: "body1",
})) as React.ComponentType<PaperProps>;
